import { Button } from "../../components/Button";

export function WelcomePage({ onStart }: { onStart: () => void }) {
  return (
    <div className="welcome">
      <section className="hero" aria-labelledby="welcome-title">
        <div className="hero__copy">
          <p className="eyebrow">Dutch financial check</p>
          <h1 id="welcome-title">Know what to reserve for local charges</h1>
          <p className="lede">
            Describe your situation in under two minutes. We’ll identify the Dutch costs,
            benefits, actions, and warnings that may apply without asking for detailed amounts.
          </p>
          <Button onClick={onStart}>Start the 2-minute check</Button>
          <p className="trust-note">Estimates only — not a bill or tax advice.</p>
        </div>
        <div className="hero__art" aria-hidden="true">
          <svg className="hero-envelope" viewBox="0 0 360 300" focusable="false">
            <path className="hero-envelope__shadow" d="M45 111h285v166H45z" />
            <path className="hero-envelope__paper" d="M84 24h194v169H84z" />
            <text className="hero-envelope__euro" x="108" y="85">€</text>
            <path className="hero-envelope__rule" d="M158 57h82M158 77h58" />
            <path className="hero-envelope__body" d="M31 95h285v166H31z" />
            <path className="hero-envelope__flap" d="m32 96 142 105L315 96" />
            <path className="hero-envelope__seam" d="m32 260 94-91M315 260l-94-91" />
          </svg>
        </div>
      </section>
      <section className="trust-grid" aria-labelledby="trust-title">
        <h2 id="trust-title">A small plan with visible evidence</h2>
        <p><strong>Calculated or clearly labelled.</strong><br />Amounts come from reviewed official rates or are labelled as planning allowances. Where we can’t put a number on something yet, we say so and show you where to check.</p>
        <p><strong>Official sources.</strong><br />Each estimate shows its assumptions, rule version, and reviewed source.</p>
        <p><strong>Your choice.</strong><br />Preview without an account. Email and reminders are optional.</p>
      </section>
    </div>
  );
}
